/**
 * Created by efowler on 4/1/14.
 */
'use strict';

frontendApp.controller('RequestReviewerModalCtrl', ['$scope', '$uibModalInstance', '$http', 'project', 'InviteService', 'HttpService', 'ConfigService', 'NotificationService', 'TokenService', function($scope, $uibModalInstance, $http, project, InviteService, HttpService, ConfigService, NotificationService, TokenService) {

    $scope.project = project;

    $scope.saving = false;

    $scope.step = 1;
    $scope.maxSteps = 1;

    $scope.close = function() {
        if ($scope.saving) return;
        $uibModalInstance.close();
    };

    $scope.request = {
        projectId: project.id,
        startDate: "",
        endDate: "",
        numReviewers: null
    };

    $scope.send = function(request) {

        $scope.saving = true;

        var data = {
            access_token: TokenService.GetAccessToken(),
            client_id: ConfigService.getClientId()
        };

        return $http.post(ConfigService.getServerBaseUrl() + '/invite/project/' + request.projectId + '/reviewer', request, { params: data  })
            .success(function(data) {
                NotificationService.addSuccess({
                    title: 'Reviewer Request Sent',
                    description: "A representative will be contacting you shortly.",
                    timeout: 5000
                });
                $scope.saving = false;
                $scope.close();

            }).error(function(data) {
                console.error(data);
                $scope.saving = false;
            });

    };




}]);

